import "../../components/button/StyledButton.css"
import AddEcomForm from "components/addEcomForm/AddEcomForm";
import { useGetEcomLatestQuery } from "api/api";
import * as z from "zod";
import { createEcomFieldValidation } from "./helpers";

const AddEcomMasonryPage = () => {
  const { data: latestEcomData = [] } = useGetEcomLatestQuery();
  const filteredEcomData = latestEcomData['ECOMData'].filter(data => data.material_category === 'Masonry');
  const materialMapping = filteredEcomData.reduce((accumulator, material) => {
    accumulator[material.material_type] = material.a1_a3_carbon_factor;
    return accumulator;
  }, {});

  const inputLabels = [
    { name: "normal_weight_masonry_block", label: "Normal Weight Masonry Block", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Normal Weight Masonry Block'], component: "FormTextField" },
    { name: "light_weight_masonry_block", label: "Light Weight Masonry Block", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Light Weight Masonry Block'], component: "FormTextField" },
    { name: "masonry_grout", label: "Masonry Grout", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['Masonry Grout'], component: "FormTextField" },
    { name: "mortar", label: "Mortar", unit: "kgCO2e/CY", value: null, type: 'number', latestValue: materialMapping['Mortar'], component: "FormTextField" },
  ];

  const inputNames = inputLabels.map((input) => input.name)

  const schema = z.object(
    Object.fromEntries(
      inputNames.map(key => [key, createEcomFieldValidation(key)])
    )
  );

  return (
    <AddEcomForm
      title="Masonry"
      inputLabels={inputLabels}
      stage={4}
      validationSchema={schema}
    />
  );
}

export default AddEcomMasonryPage;